<template>
  <div class="fixed-box">
    <div class="quick_links_panel">
      
      <div class="quick_links">

        <router-link to="/center/user" tag="a" class="link-wrap arr">
          <i class="icon setting"></i>
        </router-link> 

        <div class="message_list arr">
            <router-link :to="{path: '/cart'}">

              <i class="icon message"></i>
              
              <div class="span">{{$t('cart')}}</div>
            </router-link>

        </div>
<!-- 优惠券 -->
        <router-link :to="{path: '/center/coupon'}" class="link-wrap arr">
          <i class="icon coupon"></i>
          <div class="mp_tooltip">{{$t('coupon')}}
            <div class="icon_arrow_right_black"></div>
          </div>
        </router-link>

<!-- 收藏 -->
        <router-link :to="{path: '/center/favourite'}" class="link-wrap arr">
          <i class="icon love"></i>
          <div class="mp_tooltip">{{$t('collection')}}
            <div class="icon_arrow_right_black"></div>
          </div>
        </router-link>

      </div>

      <div class="quick_links quick_links_allow_gotop">

        <div class="link-wrap arr" @click="openService"> 
          <i class="icon kfzx"></i>
          <div class="mp_tooltip">{{$t('service')}}
            <div class="icon_arrow_right_black"></div>
          </div>
        </div>


        <!-- <div class="link-wrap arr">
          <i class="icon qrcode"></i>
          <div class="mp_qrcode">
            <img src="@/assets/images/home/qrcode.png" alt="">
            <i class="icon_arrow_white"></i>
          </div>
        </div> -->


        <div class="link-wrap arr" @click="scrollToTop" >
          <i class="icon gotop"></i>
        </div>

      </div>
    </div> 
  </div>
</template>

<script>
import { mapState } from "vuex";
export default {
  name: "ScrollToTop",
  components: {},
  props: {},
  data() {
    return {
      toTopShow: false,
      showQrcode:false
    };
  },
  watch: {},
  computed: {
    ...mapState({
      cartNums: "cartNums"
    })
  },
  methods: {
    openService() {
      // _AIHECONG("showChat"); //合从
      // window.open('http://p.qiao.baidu.com/cps/chat?siteId=7238656&userId=10953121', '_blank')
    },
    handleScroll() {
      this.scrollTop = this.scrollTop =
        window.pageYOffset || document.body.scrollTop;
      if (this.scrollTop > 300) {
        this.toTopShow = true;
      } else {
        this.toTopShow = false;
      }
    },
    scrollToTop() {
      let timer = null,
        that = this;
      cancelAnimationFrame(timer);
      timer = requestAnimationFrame(function fn() {
        if (that.scrollTop > 0) {
          that.scrollTop -= 500;
          document.body.scrollTop = document.documentElement.scrollTop =
            that.scrollTop;
          timer = requestAnimationFrame(fn);
        } else {
          cancelAnimationFrame(timer);
          that.toTopShow = false;
        }
      });
    },
    showChat(){
      // _AIHECONG('showChat')
    }
  },
  created() {},
  mounted() {
    this.$nextTick(function() {
      window.addEventListener("scroll", this.handleScroll);
    });
    
  },
  destroyed() {
    window.removeEventListener("scroll", this.handleScroll);
  }
};
</script>
<style lang="scss" scoped>
@import "@/assets/css/variable.scss";
.quick_links_panel {
  width: 40px;
  position: fixed;
  right: 0;
  bottom: 0;
  z-index: 9;
  height: 100%;
  background: #444851;
  .quick_links {
    position: absolute;
    top: 50%;
    left: 0;
    margin-top: -190px;
    background: #444851;
    z-index: 2;
    width: 40px;
    cursor: pointer;
    font-size: 12px;

    

    .arr {
      .icon {
        background: url('~@/assets/images/home/ibar_sprites.png') no-repeat;
        display: inline-block;
        position: absolute;
        left: 50%;
        top: 50%;
        transform: translate(-50%, -50%);
        width: 18px;
        height: 19px;
        &.setting {
          background-position:0 0;
        }
        &.coupon {
          background-position:0 -57px;
        }
        &.love {
          background: url('~@/assets/images/home/love.png') no-repeat;
          width: 30px;
          height: 30px;
          top: 16px;
          left: 18px;
        }
        &.kfzx{
          background-position:0 -175px;
        }
        &.gotop {
          background-position:0 -201px;
        }

        &.qrcode{
          background-position:0 -302px;
        }
      }
      &:hover {
        background: $theme-color;
        color: #fff;
        .icon {
          &.setting {
            background-position:-33px 0;
          }
          &.message {
            background-position: -33px -29px;
          }
          &.coupon {
            background-position: -33px -57px;
          }
          &.kfzx {
            background-position: -33px -175px;
          }
          &.gotop {
            background-position:  -33px -201px;
          }
        }

        &.link-wrap {
          .mp_tooltip{
            visibility: visible;
            animation: waggle 0.3s ease-in forwards;
          }
          .mp_qrcode {
            display: block;
          }
        }
      }
    }
    .link-wrap {
      position: relative;
      width: 40px;
      height: 38px;
      display: inline-block;
      .mp_tooltip {
        height: 38px;
        line-height: 38px;
        width: 92px;
        position: absolute;
        z-index: 2;
        left: -121px;
        top: 0;
        background: #444851;
        color: #d8d8d8;
        text-align: center;
        display: block;
        visibility: hidden;
        .icon_arrow_right_black {
          background: url('~@/assets/images/home/ibar_sprites.png') no-repeat;
          position: absolute;
          right: -5px;
          top: 15px;
          width: 5px;
          height: 9px;
          background-position: 0 -234px;
          overflow: hidden;
        }
      }
      .mp_qrcode{
        padding: 10px;
        width: 148px;
        height: 175px;
        top: -157px;
        background: #fff;
        box-shadow: 0 0 5px rgba(0,0,0,.4);
        border-radius: 5px 0 0 5px;
        border-left: 1px solid #ccc;
        border-top: 1px solid #ccc;
        border-bottom: 1px solid #ccc;
        z-index: 3;
        position: absolute;
        left: -168px;
        left: -169px;
        display: none;
      }
    }
    .message_list {
      background: url('~@/assets/images/home/ibar_sprites.png') no-repeat;
      line-height: 16px;
      height: 133px;
      background-position: -23px -225px;
      color: #fff;
      margin: 20px 0 10px;
      position: relative;
      .message {
        background-position: 0px -29px;
        width: 23px;
        height: 18px;
        top: 30px;
      }
      .span {
        width: 16px;
        display: block;
        height: 48px;
        margin: 50px 0 0 14px;
        cursor: pointer;
        position: absolute;
        font-size: 12px;
        margin-left: 8px;
      }
    }
    &.quick_links_allow_gotop {
      bottom: 0;
      top: initial;
    }
  }

  
}
.qrcode-li{
  position: relative;
  .qrcode{
    width: 100px;
    height: 100px;
    background:#FFF;
    position: absolute;
    top:0;
    left:-300px;
    z-index: 9999;
    img{
      width: 80px;
      height: 80px;
      margin:10px auto;
    }
  }
}
.fixed-box {
  position: fixed;
  right: 0px;
  bottom: 90px;
  z-index: 999;
  ul {
    background-color: #fff;
    width: 80px;
    margin-bottom: 20px;
    li {
      width: 80px;
      height: 88px;
      text-align: center;
      border-bottom: 1px solid $border;
      cursor: pointer;
      a {
        display: block;
        width: 100%;
        height: 100%;
        padding-top: 20px;
        color: #757575;
        box-sizing: border-box;
        transition: 0.3s;
        .icon {
          display: block;
          width: 30px;
          height: 30px;
          margin: 0 auto 10px;
          font-size: 30px;
          &.iconcart {
            position: relative;
            .nums {
              position: absolute;
              width: 14px;
              height: 14px;
              right: -12px;
              top: -5px;
              font-size: 10px;
              text-align: center;
              line-height: 14px;
              background: $theme-color;
              color: #fff;
              border-radius: 50%;
              border: 2px solid #fff;
            }
          }
        }
        &:hover {
          color: $theme-color;
          .icon {
            color: $theme-color;
          }
        }
      }
    }
  }
}
.top {
  background-color: #fff;
  width: 80px;
  height: 88px;
  cursor: pointer;
  color: #757575;
  transition: 0.3s;
  z-index: 100;
  text-align: center;
  box-sizing: border-box;
  padding-top: 20px;
  visibility: hidden;
  .icon {
    display: block;
    font-size: 30px;
    margin-bottom: 10px;
  }
  &.active {
    visibility: visible;
  }
  &:hover {
    color: $theme-color;
    opacity: 0.8;
    .icon {
      color: $theme-color;
    }
  }
}

@keyframes waggle {
  0% {
    left: -120px;
  }
  100% {
    left: -90px;
  }
}
</style>